export default __webpack_public_path__ + "static/media/V120_RoHS.2dd09475.pdf";